// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function HRImpProductRow() {
   const state = useQuoteContext()
   const { getString } = state

   if (
      state.user_view == 'Internal' ||
      state.hrImplementationCosts.totalPrice > 0
   )
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {getString('product.HRImpProductRow.ProductName')}
            </div>
            <div className='col-bhr2'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {'totalPriceWithoutExtraCountryCost' in
                  state.hrImplementationCosts &&
                  formatFloatAsCurrencySymbol(
                     state.hrImplementationCosts
                        .totalPriceWithoutExtraCountryCost,
                     state.currencyObject,
                  )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col'></div>
                  <div className='col'></div>
               </>
            ) : (
               <></>
            )}
         </div>
      )
}
